<template>
  <div class="my_module_animation">
    <ul class="animation_list">
      <li
        class="animation_item"
        v-for="(item, index) in moduleAnimationList"
        :key="index"
        :data-active="index === activeIndex"
        @click="change_item(index)"
      >
        <div class="animation_img">
          <div
            v-if="index === 0"
            class="type_img"
          >{{$t('view_left_sidebar_page_setting_full_page_setting_258')}}</div>
          <div
            v-else
            class="type_img"
            :class="`type_img_${index}`"
          ></div>
          <span class="active-icon el-icon-check"></span>
        </div>
        <div class="animation_title">{{ item.typeTitle }}</div>
      </li>
    </ul>
    <div class="animation_setting">
      <div
        class="setting_item setting_radio"
        v-if="moduleAnimationList[activeIndex].direction"
      >
        <span class="setting_title">{{$t('components_my_animation_my_comb_animation_2289')}}</span>
        <div class="setting_content">
          <el-radio-group v-model="moduleAnimationList[activeIndex].formData.direction">
            <el-radio
              :label="key"
              v-for="(item, key) in moduleAnimationList[activeIndex].direction"
              :key="key"
            >{{$t(item)}}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div
        class="setting_item setting_slider"
        v-if="moduleAnimationList[activeIndex].duration"
      >
        <span
          class="setting_title"
          style="margin-bottom: 14px;"
        >{{$t('components_my_animation_my_module_animation_2291')}}</span>
        <div class="setting_content m-l-6">
          <my_slider
            symbol="s"
            :value.sync="moduleAnimationList[activeIndex].formData.duration"
            :step="0.2"
            :min="0"
            :max="10"
            num-type="float"
          >
          </my_slider>
        </div>
      </div>
      <div
        class="setting_item setting_slider"
        v-if="moduleAnimationList[activeIndex].delay"
      >
        <span
          class="setting_title"
          style="margin-bottom: 14px;"
        >{{$t('widgets_basic_floating_frame_edit_535')}}</span>
        <div class="setting_content m-l-6">
          <my_slider
            symbol="s"
            :value.sync="moduleAnimationList[activeIndex].formData.delay"
            :step="0.2"
            :min="0"
            :max="10"
            num-type="float"
          >
          </my_slider>
        </div>
      </div>
      <div
        class="setting_item setting_radio setting_trigger"
        v-if="moduleAnimationList[activeIndex].trigger"
      >
        <span class="setting_title">{{$t('widgets_basic_classification_edit_461')}}</span>
        <div class="setting_content">
          <el-radio-group v-model="moduleAnimationList[activeIndex].formData.trigger">
            <el-radio
              :label="key"
              v-for="(item, key) in moduleAnimationList[activeIndex].trigger"
              :key="key"
            >{{item}}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div
        class="setting_item setting_loop"
        v-if="moduleAnimationList[activeIndex].loop"
      >
        <span class="setting_title">{{$t('components_my_animation_my_module_animation_2292')}}</span>
        <div class="setting_content">
          <el-select
            v-model="moduleAnimationList[activeIndex].formData.loop"
            style="width: 130px;"
          >
            <el-option
              v-for="(item, index) in moduleAnimationList[activeIndex].loop"
              :key="index"
              :label="item"
              :value="index"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import moduleAnimationList from './module_animation_list.js'

export default {
  name: 'my_module_animation',
  props: {
    defalutActive: {
      type: Number,
      default: 0
    },
    defaultFormData: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    moduleAnimationList: {
      handler (val) {
        this.$emit('change', { typeTitle: val[this.activeIndex].typeTitle, id: val[this.activeIndex].id, formData: val[this.activeIndex].formData })
      },
      deep: true
    },
    activeIndex (val) {
      this.$emit('change', { typeTitle: this.moduleAnimationList[val].typeTitle, id: this.moduleAnimationList[val].id, formData: this.moduleAnimationList[val].formData })
    }
  },
  data () {
    return {
      moduleAnimationList: JSON.parse(JSON.stringify(moduleAnimationList)),
      activeIndex: this.defalutActive
    }
  },
  mounted () {
    if (this.defaultFormData) {
      this.moduleAnimationList[this.activeIndex].formData = this.defaultFormData
    }
    // this.$emit('change', { typeTitle: this.moduleAnimationList[this.activeIndex].typeTitle, id: this.moduleAnimationList[this.activeIndex].id, formData: this.moduleAnimationList[this.activeIndex].formData })
  },
  methods: {
    change_item (index) {
      this.activeIndex = index
    },
    change_slider (val) {
      console.log(val)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/css/global-variable.scss";
.my_module_animation {
  .animation_list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 22px;
    .animation_item {
      margin: 7px 0;
      .animation_img {
        position: relative;
        margin: 0 3px;
        width: 76px;
        height: 76px;
        border: 1px solid #e1e1e1;
        .active-icon {
          display: none;
          width: 18px;
          height: 16px;
          color: #fff;
          position: absolute;
          bottom: 0;
          right: 0;
          background-color: #5874d8;
          line-height: 22px;
          font-size: 12px;
          padding: 0 3px;
          border-top-left-radius: 100%;
        }
        .type_img {
          width: 100%;
          height: 100%;
          line-height: 76px;
          text-align: center;
          background: url(~@/assets/image/cssSprite.png) no-repeat;
          &.type_img_1 {
            background-position: -48px -438px;
          }
          &.type_img_2 {
            background-position: -124px -438px;
          }
          &.type_img_3 {
            background-position: -200px -438px;
          }
          &.type_img_4 {
            background-position: -276px -438px;
          }
          &.type_img_5 {
            background-position: -352px -438px;
          }
          &.type_img_6 {
            background-position: -428px -438px;
          }
          &.type_img_7 {
            background-position: -504px -438px;
          }
          &.type_img_8 {
            background-position: -580px -438px;
          }
          &.type_img_9 {
            background-position: -656px -438px;
          }
        }
        &:hover {
          border-color: $theme-primary;
        }
      }
      .animation_title {
        text-align: center;
        cursor: pointer;
      }
      &[data-active] {
        .animation_img {
          border-color: $theme-primary;
          .active-icon {
            display: block;
          }
        }
      }
    }
  }
  .animation_setting {
    border-top: 1px dashed #def0ff;
    padding-top: 30px;
    .setting_item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      .setting_title {
        display: inline-block;
        // width: 50px;
        width: auto;
        text-align: right;
        vertical-align: middle;
        flex-shrink: 0;
        font-size: 13px;
        line-height: 1;
      }
      .setting_content {
        flex: 1;
        margin-left: 8px;
      }
      .m-l-6 {
        margin-left: 5px;
      }
      &.setting_radio {
        align-items: flex-start;
        min-height: 40px;
        .setting_content {
          display: inline-block;
          /deep/ .el-radio {
            margin: 0 15px 15px 0;
          }
        }
        &.setting_trigger {
          align-items: center;
          margin-bottom: 15px;
          .setting_content {
            /deep/ .el-radio {
              margin: 0 15px 0 0;
            }
          }
        }
      }
      &.setting_slider {
        .setting_title {
          margin-bottom: 8px;
        }
        .setting_content {
          flex: 0 0 220px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          /deep/ .my_slider_layer {
            .module {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
}
</style>

<style>
.my_module_animation .m-l-6 .setting_title {
  margin-left: 6px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/my_animation/my_module_animation.vue